import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { withStyles } from '@mui/styles';

import { fetchAllTypeaheadProjectsInCompany, clearTypeahed } from '../../../actions';
import MultiTypeahead from './MultiTypeahead';
import renderMultiSuggestion from '../RenderMultiSuggestion';

const styles = {
    projectValueContainer: {
        minWidth: 0,
        maxWidth: '330px'
    }
};

class ProjectsTypeahead extends Component {
    static propTypes = {
        classes: PropTypes.object.isRequired,
        labelId: PropTypes.string,
        fetchAllTypeaheadProjectsInCompany: PropTypes.func,
        clearTypeahed: PropTypes.func.isRequired,
        suggestions: PropTypes.array,
        required: PropTypes.bool,
        disabled: PropTypes.bool,
        error: PropTypes.string,
        onChangeSuggestion: PropTypes.func.isRequired,
        value: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
        isMulti: PropTypes.bool,
        animatedPlaceholder: PropTypes.bool,
        renderMultiSuggestion: PropTypes.func
    };

    static defaultProps = {
        labelId: 'project',
        suggestions: [],
        renderMultiSuggestion
    };    

    state = {
        isLoading: false
    };

    onFocus = async () => {
        this.setState({ isLoading: true });

        try {
            await this.props.fetchAllTypeaheadProjectsInCompany(ProjectsTypeahead.name);
        } finally {
            this.setState({ isLoading: false });
        }
    };

    render() {
        const {
            required = false,
            disabled,
            error,
            labelId,
            isMulti,
            animatedPlaceholder,
            suggestions,
            value,
            clearTypeahed,
            onChangeSuggestion,
            renderMultiSuggestion,
            classes,
            t
        } = this.props;

        const options = suggestions.map(project => ({
            label: project.name,
            value: project.id
        }));        

        return (
            <MultiTypeahead
                classes={{
                    valueContainer: classes.projectValueContainer
                }}
                options={options}
                isMulti={isMulti}
                isLoading={this.state.isLoading}
                value={value}
                titleId={labelId}
                animatedPlaceholder={animatedPlaceholder}
                onChangeSuggestion={onChangeSuggestion}
                handleSuggestionsClearRequested={clearTypeahed}
                onFocus={this.onFocus}
                formatOptionLabel={renderMultiSuggestion}
                error={error}
                disabled={disabled}
                required={required}
                t={t}
            />
        );
    }
}

const mapStateToProps = ({ typeahead }) => ({
    suggestions:
        typeahead.source === ProjectsTypeahead.name ? typeahead.list : ProjectsTypeahead.defaultProps.suggestions,
});

export default connect(mapStateToProps, {
    fetchAllTypeaheadProjectsInCompany,
    clearTypeahed
})(withStyles(styles, { withTheme: true })(ProjectsTypeahead));
